/**
 * CategorySelect - Selector de categorías reutilizable
 * 
 * Usado en filtros de gastos, inventario, productos, etc.
 */
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";

export interface Category {
    id: string;
    name: string;
}

interface CategorySelectProps {
    /** Lista de categorías disponibles */
    categories: Category[];
    /** Valor seleccionado (id de la categoría o empty string para "todas") */
    value: string;
    /** Callback cuando cambia la selección */
    onChange: (value: string) => void;
    /** Placeholder cuando no hay selección */
    placeholder?: string;
    /** Texto para la opción "todas" */
    allLabel?: string;
    /** Clases adicionales para el trigger */
    className?: string;
}

const CategorySelect = ({
    categories,
    value,
    onChange,
    placeholder = "Todas las categorías",
    allLabel = "Todas las categorías",
    className = "w-[180px] rounded-full bg-gray-100 hover:bg-gray-200 transition-colors border-0",
}: CategorySelectProps) => {
    return (
        <Select
            value={value || "all"}
            onValueChange={(val) => onChange(val === "all" ? "" : val)}
        >
            <SelectTrigger className={className}>
                <SelectValue placeholder={placeholder} />
            </SelectTrigger>
            <SelectContent>
                <SelectItem value="all">{allLabel}</SelectItem>
                {categories.map((category) => (
                    <SelectItem key={category.id} value={category.id}>
                        {category.name}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
};

export default CategorySelect;
